const style = {
  wrap: {
    paddingTop: '10px',
    // padding: '10px 25px 40px',
    background: '#ffffff7a',
    position: 'relative',
    height: '100%',
    // minHeight: 'calc(100vh - 310px)',
  },
  wrapForm: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  view: {
    minHeight: '75vh',
    overflowX: 'auto',
    display: 'flex',
    margin: '10px 0px',
    paddingBottom: '15px',
  },
  modalText: {
    textAlign: 'center',
  },
  button: {
    margin: '8px -8px',
  },
  searchWrap: {
    marginBottom: '3px',
  },
  error: {
    color: '#FF0000',
  },
  xeroConnectionWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: '30px',
  },
  mr30: { marginRight: '30px' },
  mr6: { marginRight: '6px' },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
  },
}

export default style
